import { graphql } from "@opensea/graphql"
import { useCollectionOffersFragment } from "../../use-collection-offers.fragment"
import {
  OfferAggregateTableRow_collectionFragment,
  OfferAggregateTableRowFragment,
} from "./OfferAggregateTableRow.fragment"

export const OfferAggregateTableFragment = graphql(
  `
    fragment OfferAggregateTable on OfferAggregate {
      id
      ...OfferAggregateTableRow
    }
  `,
  [OfferAggregateTableRowFragment],
)

export const OfferAggregateTable_collectionFragment = graphql(
  `
    fragment OfferAggregateTable_collection on Collection {
      ...useCollectionOffers
      ...OfferAggregateTableRow_collection
    }
  `,
  [useCollectionOffersFragment, OfferAggregateTableRow_collectionFragment],
)
